module.exports = __webpack_public_path__ + "russo-one-v8-latin-regular.woff?e89ab14590c2e386bd695d43996c63eb";